import React from "react";

import "./Input.scss";

const Input = ({
  register = () => {},
  name,
  errorMessage,
  additionalError,
  additionalSettings,
  ...rest
}) => {
  return (
    <div className="InputField">
      <input
        className="Input"
        {...register(name, additionalSettings)}
        {...rest}
      />
      <div className="Error-Container">{errorMessage || additionalError}</div>
    </div>
  );
};

export default Input;
